import React from 'react';
import { TKeyMetricsItem } from '../../../kpiTypes';
import MetricsCard from '../../../../../shared/components/metricsCard/MetricsCard';

export interface IKeyMetricsProps {
	keyMetricsData: TKeyMetricsItem | null;
}

const VoyagesStats: React.FC<IKeyMetricsProps> = ({ keyMetricsData }) => {
	return (
		<div className="flex flex-row w-full h-full gap-8">
			<div className="flex flex-col space-y-4 h-full w-full whitespace-nowrap">
				<MetricsCard
					metrics={[
						{ label: '# Voyages', value: keyMetricsData?.voyagesCount },
						{ label: 'Average Voyage Distance (nm)', value: keyMetricsData?.averageVoyageDistance },
						{ label: 'Average Voyage Time (Days)', value: keyMetricsData?.averageVoyageDays },
						{ label: 'Average Origin Port Time (Days)', value: keyMetricsData?.averageDaysInOriginPort },
						{ label: 'Average Destination Port Time (Days)', value: keyMetricsData?.averageDaysInDestinationPort },
					]}
				/>
			</div>

			<div className="flex flex-col space-y-4 h-full w-full whitespace-nowrap">
				<MetricsCard
					metrics={[
						{ label: 'Average Voyage Fuel Consumed (T)', value: keyMetricsData?.averageFuelConsumed },
						{ label: 'Average Voyage Emissions (T)', value: keyMetricsData?.averageCo2Emissions },
					]}
				/>
			</div>
		</div>
	);
};

export default VoyagesStats;
